export default {
  invalidDateMessage: {
    id: 'INPUT-DATE_INVALID_DATE_ERROR',
    description: 'Input date invalid date format text message',
    defaultMessage: 'Invalid date format',
  },
};
